import { render, staticRenderFns } from "./projectDetail.vue?vue&type=template&id=271fab5e&scoped=true"
import script from "./projectDetail.vue?vue&type=script&lang=js"
export * from "./projectDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/articleDetail.css?vue&type=style&index=0&id=271fab5e&prod&scoped=true&lang=css&external"
import style1 from "./projectDetail.vue?vue&type=style&index=1&id=271fab5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271fab5e",
  null
  
)

export default component.exports